// Api
import authenticationApi from './api';

// Action Types
import {
  LOGIN_USER, FETCH_USER_INFO, FETCH_PROFILE, FETCH_USER_LOCATION
} from './actionTypes';

// Utils
import { isDefined } from '../shared/utils/is';
import { apiFetch as fetchUserLocationApi } from '../shared/utils/iplocation';
import { extractOutcode, URLOfEnclosingWebPage } from '../shared/utils/userLocation';


export const loginUser = (username, password) => dispatch => {
  const requestLoginUser = () => ({
    type: LOGIN_USER.request()
  });

  const receivedToken = token => ({
    type: LOGIN_USER.success(),
    payload: token
  });

  const errorOnLoginUser = error => ({
    type: LOGIN_USER.error(),
    payload: error
  });

  dispatch(requestLoginUser());

  return authenticationApi.loginUser(username, password)
    .then(({ token }) => {
      dispatch(receivedToken(token));
      dispatch(fetchProfile(token));
    })
    .catch(error => dispatch(errorOnLoginUser(error)));
};

export const loginGuestUser = (params = {}) => dispatch => {
  const requestLoginGuestUser = () => ({
    type: LOGIN_USER.request()
  });

  const receivedToken = token => ({
    type: LOGIN_USER.success(),
    payload: token
  });

  const errorOnLoginGuestUser = error => ({
    type: LOGIN_USER.error(),
    payload: error
  });

  dispatch(requestLoginGuestUser());

  return authenticationApi.loginGuestUser(params)
    .then(({ token }) => {
      dispatch(receivedToken(token));
      dispatch(fetchProfile(token));
    })
    .catch(error => dispatch(errorOnLoginGuestUser(error)));
};

export const fetchUserInfo = (token) => dispatch => {
  const requestFetchUserInfo = () => ({
    type: FETCH_USER_INFO.request()
  });

  const receivedUserInfo = userInfo => ({
    type: FETCH_USER_INFO.success(),
    payload: userInfo
  });

  const errorOnFetchUserInfo = error => ({
    type: FETCH_USER_INFO.error(),
    payload: error
  });

  dispatch(requestFetchUserInfo());

  return authenticationApi.fetchUserInfo(token)
    .then(({ data }) => dispatch(receivedUserInfo(data)))
    .catch(error => dispatch(errorOnFetchUserInfo(error)));
};

export const fetchProfile = (token) => dispatch => {
  const requestFetchProfile = () => ({
    type: FETCH_PROFILE.request()
  });

  const receivedProfile = userInfo => ({
    type: FETCH_PROFILE.success(),
    payload: userInfo
  });

  const errorOnFetchProfile = error => ({
    type: FETCH_PROFILE.error(),
    payload: error
  });

  dispatch(requestFetchProfile());

  return authenticationApi.fetchProfile(token)
    .then(({ data, zone, account }) => dispatch(receivedProfile({ data, zone, account })))
    .catch(error => dispatch(errorOnFetchProfile(error)));
};

export const fetchUserLocation = () => dispatch => {
  const requestFetchUserLocation = () => ({
    type: FETCH_USER_LOCATION.request()
  });

  const receivedUserLocation = userLocation => ({
    type: FETCH_USER_LOCATION.success(),
    payload: userLocation
  });

  const errorOnFetchUserLocation = error => ({
    type: FETCH_USER_LOCATION.error(),
    payload: error
  });

  dispatch(requestFetchUserLocation());

  return fetchUserLocationApi()
    .then(location => {
      const { latitude, longitude, postal } = location;
      const userLocation = {
        latitude,
        longitude,
        postalcode: extractOutcode(postal)
      };
      return userLocation;
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.log(`Error occurred in fetchUserLocationApi: ${error}`);
    })
    .then(userLocation => {
      const url = URLOfEnclosingWebPage();

      if (userLocation === undefined) {
        userLocation = {
          latitude: 1,
          longitude: 1
        };
      }

      if (!isDefined(userLocation.postalcode)) {
        userLocation.postalcode = '*WEB';
      }

      userLocation.referer = isDefined(url) ? url : '*REF';

      dispatch(receivedUserLocation(userLocation));
    }).catch(error => dispatch(errorOnFetchUserLocation(error)));
};
